import React, { useState } from 'react';
import PropTypes from 'prop-types';
import IMAGES from 'modules/assets/web';
import { Link } from 'react-router-dom';
import { Modal, ModalBody } from 'reactstrap';

const CompletedQuestionnaireModal = props => {
  const [isVisible, setIsVisible] = useState(true);
  return (
    <Modal
      id="completed-questionnaire-modal"
      // handleHideModal={props.handleHideModal}
      isOpen={isVisible}
      modalStyles="cwa-modal"
    >
      <ModalBody>
        <div className="ml-4 mr-4">
          <img
            alt="Victory!"
            className="d-block mx-auto mb-2 mw-100"
            src={IMAGES.ONBOARDING_SUCCESS_FISTBUMP}
          />
          <p>
            Phase One complete, {props.myClient.data[0].firstName}! Thanks for
            all the info!
          </p>
          <p>
            We{`’`}ll use these answers along with the notes from your initial
            call with to match you up with a Nerd Fitness Coach who has the
            strengths to help you succeed! Once you’re up on the waiting list,
            we’ll be in touch with more information about your Coach and then
            the real fun begins!
          </p>
          <p>
            For now: deep breaths, 5 burpees, and click below for a message from
            Rebel One!
          </p>

          <Link
            className="nav-link text-primary"
            to="/questionnaire-complete"
            onClick={() => setIsVisible(false)}
          >
            <button
              type="button"
              className="btn btn-outline-primary btn-lg mx-auto d-block"
            >
              To the Steve Cave, Batman!
            </button>
          </Link>
        </div>
      </ModalBody>
    </Modal>
  );
};

CompletedQuestionnaireModal.propTypes = {
  // title: PropTypes.string,
  // handleHideModal: PropTypes.func.isRequired,
  myClient: PropTypes.object.isRequired,
};

CompletedQuestionnaireModal.defaultProps = {
  // title: 'Whoohoo, all done!',
};

export default CompletedQuestionnaireModal;
